// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1783680369975
      var cssReload = require("D:/work/admin/colocess_web_manage/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  